import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import HeaderTabla from '../componentes/HeaderTabla'
import BotonesFormulario from '../componentes/BotonesFormulario'
import moment from 'moment'

const VerCampanasCliente = ({ data }) => {



	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['id', 'Fecha', 'Mensaje Masivo']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td>{item.id}</td>
								<td>{item.fecha_envio}</td>
								<td>{item.mensaje}</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerCampanasCliente